module.exports = __webpack_public_path__ + "static/media/tn.f07a886c.svg";